/**
 * Функция копирования нового сета
 * @param set
 */
export const copySet = <T>(set: Set<T>): Set<T> => {
  return new Set(Array.from(set));
};
